'use strict';
var inputs = document.querySelectorAll('input');
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = inputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var input = _step.value;
        var label = document.createElement('label');
        label.className = 'field-label';
        label.htmlFor = input.id;
        label.textContent = input.name;
        var placeholder = input.name[0].toUpperCase() + input.name.slice(1);
        input.placeholder = placeholder;
        input.parentElement.prepend(label);
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}

//# sourceMappingURL=js_task_fix_form_DOM.d08803c7.js.map
